export enum RaceEnum {
    AmericanIndianOrAlaskaNativeDescription = 'American Indian or Alaska Native',
    AmericanIndianOrAlaskaNative = 1,
    AsianDescription = 'Asian',
    Asian = 2,
    BlackOrAfricanAmericanDescription = 'Black or African American',
    BlackOrAfricanAmerican = 3,
    HispanicDescription = 'Hispanic or Lation',
    HispanicOrLatino = 4,
    WhiteDescription = 'White',
    White = 5,
}
